<template>
  <v-dialog
    v-model="isModalOpened"
    max-width="45%"
    transition="dialog-bottom-transition"
    @click:outside="closeModal"
  >
    <v-card>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-row class="ma-0">
            <v-col cols="10" class="pa-0 d-flex align-center">
              <h2 class="my-0">
                Report Traffic
              </h2>
            </v-col>
            <v-col cols="2" class="pa-0 d-flex justify-end">
              <v-btn
                  class="px-0"
                  @click="closeModal"
                  fab
                  text
                  height="auto"
              >
                <v-icon large>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5.5" class="py-0 pr-0">
              <h3 class="font-weight-regular mb-0">
                Traffic Source
              </h3>
              <span class="horizontal-divider" />
              <v-row align="center" class="mt-0">
                <v-col height="36" cols="5">
                  <label class="font-weight-bold">
                    Affiliate:
                  </label>
                </v-col>
                <v-col height="36" cols="6" class="px-0">
                  <custom-select
                      :options="getActiveAffiliates"
                      v-model="affiliateSelected"
                      label="affiliateName"
                      @search="updateAffiliates"
                      class="custom_select"
                  />
                </v-col>

                <v-col height="36" cols="5" :class="disabledEnabledElement('label')">
                  <label class="font-weight-bold">
                    Campaign:
                  </label>
                </v-col>
                <v-col height="36" cols="6" class="pt-0 px-0">
                  <v-text-field
                      solo
                      placeholder="Enter Campaign"
                      hide-details="auto"
                      :disabled="this.isAffiliateBlacklisted"
                      v-model="campaignIdInput"
                      :class="disabledEnabledElement('input')"
                      class="input-slot"
                      :rules="campaignValidation"
                  />
                </v-col>

                <v-col height="36" cols="5" :class="disabledEnabledElement('label')">
                  <label class="font-weight-bold">
                    Sub-Campaign:
                  </label>
                </v-col>
                <v-col height="36" cols="6" class="pt-0 px-0">
                  <v-text-field
                      solo
                      placeholder="Enter Sub-Campaign"
                      hide-details="auto"
                      :class="disabledEnabledElement('input')"
                      class="input-slot"
                      :disabled="isAffiliateBlacklisted"
                      v-model="subCampaignInput"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="d-flex justify-center align-end px-0 pt-15">
              <span class="vertical-divider" />
            </v-col>
            <v-col cols="5.5" class="py-0">
              <h3 class="font-weight-regular mb-0">
                Action
                <v-tooltip bottom >
                  <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on"
                        >
                          <i class="fa fa-info-circle tooltipColor" aria-hidden="true"></i>
                        </span>
                  </template>
                  <span>
                        * Block Traffic: will send the traffic from the selected source to Exit Traffic  <br /><br />

                        * Block Payments: will prevent the affiliate from being paid. It is highly recommended that blocked payments get solved before the Payment Term is due<br /><br />

                        * Blacklist: all the affiliate’s traffic is physically blocked and all Payments are blocked.<br /><br />
                      </span>
                </v-tooltip>
              </h3>
              <span class="horizontal-divider" />
              <v-row align="center" class="mt-0">
                <v-col cols="12" class="checkbox-group">
                  <v-checkbox
                      :class="disabledEnabledElement('checkbox') + ' mt-0'"
                      color="success"
                      v-model="isBlockTraffic"
                      :disabled="this.isAffiliateBlacklisted"
                      :label="'Block Traffic'"
                  />
                  <v-checkbox
                      v-model="isBlockPayments"
                      color="success"
                      :class="disabledEnabledElement('checkbox') + ' mt-2'"
                      :disabled="this.isAffiliateBlacklisted"
                      :label="'Block Payments'"
                  />
                  <v-checkbox
                      v-model="isAffiliateBlacklisted"
                      color="success"
                      class="mt-2"
                      @click="blackListedAction()"
                      :label="'Blacklist'"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" class="mt-1">
            <v-col height="36" cols="2" :class="disabledEnabledElement('label')">
              <label class="font-weight-bold">
                Blocked Countries:
              </label>
            </v-col>
            <v-col  height="36">
              <custom-select
                  :options="getCountries"
                  v-model="selectedCountries"
                  label="name"
                  :multiple="true"
                  @search="filterCountry"
                  class="custom_select"
              />
              <div>
                {{ selectedCountriesString }}
              </div>

            </v-col>
          </v-row>

          <v-row class="mx-0 mt-5">
            <v-col cols="12" class="px-0">
              <v-textarea
                  v-model="blockReason"
                  solo
                  class="contextInput"
                  name="input-7-4"
                  label="Write reason for reporting the traffic. Mandatory if blocking payments"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col class="text-right pt-0 px-0">
              <v-btn
                  @click="report"
                  color="primary"
                  dark
                  width="150"
              >
                Report
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "reportTraffic",
  props: {
    isModalOpened: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    this.$store.dispatch('countries/saveCountriesStore')
  },
  data() {
    return {
      selectedCountries: [],
      isBlockTraffic: false,
      isBlockPayments: false,
      isAffiliateBlacklisted: false,
      affiliateSelected: '',
      blockReason: '',
      campaignIdInput: '',
      campaignValidation: [
        value => Number.isInteger(Number(value)) || "The value must be an integer number"
      ],
      subCampaignInput: ''
    }
  },
  computed: {
    ...mapGetters('countries', ['getCountries']),
    selectedCountriesString() {
      return this.selectedCountries.map(country => country.code).join(', ');
    },
    ...mapGetters('blocking', ['getActiveAffiliates']),
  },
  methods: {
    ...mapMutations('countries', ['filterCountry']),
    closeModal() {
      this.$emit('closeModal')
    },
    report() {
      this.$emit('report', {
        affiliateSelected: this.affiliateSelected,
        isAffiliateBlacklisted: this.isAffiliateBlacklisted,
        isBlockPayments: this.isBlockPayments,
        isBlockTraffic: this.isBlockTraffic,
        campaignIdInput: this.campaignIdInput,
        subCampaignInput: this.subCampaignInput,
        blockReason: this.blockReason,
        blockCountries: this.selectedCountriesString
      })

      this.affiliateSelected = ''
      this.campaignIdInput=''
      this.subCampaignInput = ''
      this.selectedCountries = []
      this.blockReason = ''
      this.isBlockTraffic = false
      this.isBlockPayments = false
      this.isAffiliateBlacklisted = false
    },
    disabledEnabledElement(name){
      let className=''
      switch (name) {
        case 'checkbox':
          className = this.isAffiliateBlacklisted ? 'trafficColorDisabled' : 'trafficColor'
          break
        case 'input':
          className = this.isAffiliateBlacklisted ? 'trafficColorDisabledInput' : 'trafficColorInput'
          break
        case 'label':
          className=  this.isAffiliateBlacklisted ? 'labelColorDisabled pt-0' : 'labelColorEnabled pt-0'
          break
      }
      return className
    },
    updateAffiliates(search, loading) {
      console.log(search, loading)
      this.$emit('updateAffiliates', search, loading)
    },
    blackListedAction(){
      if (this.isAffiliateBlacklisted){
        this.isBlockTraffic = false
        this.isBlockPayments = false
        this.campaignIdInput = ''
        this.subCampaignInput = ''
      }
    },
  }
}
</script>

<style lang="sass">
.horizontal-divider
  border: 1px solid #ACC3CF
  width: 100%
  display: inline-block

.vertical-divider
  border: 1px solid #ACC3CF
  height: 145px

.input-slot
  .v-input__control
    height: 36px !important
    min-height: initial !important

.checkbox-group
  .v-input
    .v-input__control
      .v-messages
        display: none !important
</style>